module.exports = __webpack_public_path__ + "static/media/circleColor_linkedin.d1b16e5d.svg";